import { computed, ComputedRef } from "vue"
import store from "store"
import { CurrentMember } from "suus-api"

export const useCurrentContext = () => {
  const isCurrentMemberLoaded: ComputedRef<boolean> = computed(
    () => store.getters["member/isCurrentMemberLoaded"]
  )

  if (!isCurrentMemberLoaded.value) {
    store.dispatch("member/getCurrentMember")
  }

  const currentMember = computed<CurrentMember>(
    () => store.getters["member/currentMember"]
  )

  const isCurrentMemberInGroup = (groupId: number) => {
    return computed(() => {
      return currentMember.value.group_memberships.includes(groupId)
    })
  }

  return {
    isCurrentMemberInGroup,
  }
}
